import { useAppContext } from '../../../../../../app/Context';
import { getTimerMetaData } from '../../../../../../db/timer';
import { useTimerContext } from '../../Context';

const useResetTimerButton = () => {
  const { presentationId, activeSlideId } = useAppContext();
  const { setCountdownStartTime, isTimerRunning } = useTimerContext();

  const handleClick = () => {
    if (!presentationId) return;
    if (!activeSlideId) return;
    if (isTimerRunning) return;
    const response = getTimerMetaData(presentationId, activeSlideId);
    if (!response) return;
    const { countdownFrom = 0 } = response;
    setCountdownStartTime(countdownFrom);
  };

  return { handleClick, isTimerRunning };
};

export default useResetTimerButton;
